import { jsx as _jsx } from "react/jsx-runtime";
import ProductCategories from 'pages/inventory/ProductCategories';
import { Navigate, Route } from 'react-router-dom';
import AuthorizationService from '../AuthorizationService';
import { Index } from 'constants/actions';
import { ProductCategory as ProductCategoryResource } from 'constants/resources';
var ProductCategoriesRoutes = function () {
    return ([
        _jsx(Route, { caseSensitive: true, path: '/product_categories', element: AuthorizationService.getAuthorizedElement(_jsx(ProductCategories, {}), Index, ProductCategoryResource) }, 'product-categories-route'),
        _jsx(Route, { caseSensitive: true, path: '/product_categories/new', element: _jsx(Navigate, { to: "/product_categories", replace: true }) }, 'new-product-categories-route')
    ]);
};
export default ProductCategoriesRoutes;
